import { buildPrimitive } from '../primitive-builder';

import styles from './full-height-container.module.scss';

export const fullHeightItemClassName = styles.fullHeightItem;

export const FullHeightContainer = buildPrimitive(styles.fullHeight, {});
